import React, { Component } from "react";
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { LOGIN_TYPE_ADMIN, ClientsAnalysis, Dashboard_API_Hit_Report, Dashboard_Mobile_App } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
//import Parser from 'html-react-parser';
//import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import Select2 from 'react-select2-wrapper';
import $ from "jquery";
import 'react-select2-wrapper/css/select2.css';
//import 'react-select2-wrapper/css/select2.css';
//import { Alert } from 'rsuite';

import Header from "./include/Header";
var leadReport;
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalClients: '--',
      totalClientsInfo: { 'Prepaid': '--', 'Postpaid': '--', 'TokenStatusActive': '--' },
      tokenActive: '--',
      tokenInActive: '--',
      tokenExpireUserInfo: [],
      loginActiveStatus: '--',
      loginInactiveStatus: '--',
      loginInactiveUserInfo: [],
      balanceExhausted: '--',
      balanceExhaustedUserInfo: [],
      tokenWillBeExpireDays: '--',
      tokenWillBeExpireUserInfo: [],
      clientist: [{ text:'All Client', id:-1, value:'all client'}],
      lastSixMont: [],
      currentMonth: '',
      selectedClient: '',
      totalHit: { 'TotalHits': '--', 'TotalFailure': '--', 'TotalOwndb': '--', 'OwndbFailure': '--', 'OwndbSucess': '--', 'TotalTimeout': '--' },
      totalHitSource: { 'TotalAlpha': '--', 'AlphaSucess': '--', 'AlphaFailure': '--', 'TotalBeta': '--', 'BetaSucess': '--', 'BetaFailure': '--', 'TotalGamma': '--', 'GammaSucess': '--', 'GammaFailure': '--', 'totalOtherHits': '--','challanTotalFailure':'--','challanTotalTimeOut': '--','challanTotalSucces': '--',
        'challanTotalNotFound': '--', 'deltatwoFailure': '--'},
      totalChallanSource : {'challanTotalApiHits' : '--','challanTotalDBHits': '--', 'challanTotalGammaSucces' : '--','challanTotalNotFoundGamma' : '--','challanGammaFailure' : '--', 'challanGammaTimeOut' : '--'},
      totalChallanZetaSource : {'challanTotalZetaSucces' : '--', 'challanZetaFailure': '--', 'challanTotalNotFoundZeta': '--', 'challanZetaTimeOut' : '--' },
      totalChallanDeltaSource : {'challanTotalDeltaSucces' : '--', 'challanDeltaFailure': '--', 'challanTotalNotFoundDelta': '--', 'challanDeltaTimeOut' : '--',
      'challanTotalDeltaProSucces' : '--', 'challanDeltaProFailure': '--', 'challanTotalNotFoundDeltaPro': '--', 'challanDeltaProTimeOut' : '--'
       },
      totalServiceHistorySource:{'serviceHitsTotal': '--', 'serviceTotalSuccess': '--', 'serviceTotalFailure': '--' },

      totalUsedCarPricingSource:{'usedCarPricingTotal': '--', 'usedCarPricingSuccess': '--','usedCarPricingTimeOut': '--', 'usedCarPricingFailure': '--' }, 
      totalUsedCarPricingV2Source:{'usedCarPricingV2Total': '--', 'usedCarPricingV2Success': '--','usedCarPricingV2TimeOut': '--', 'usedCarPricingV2Failure': '--' }, 
      totalFreeRCSource:{'freeRCTotal': '--', 'freeRCSuccess': '--','freeRCTimeOut': '--', 'freeRCFailure': '--' },  

      mobileApplication: { 'TotalLeads': '--', 'apiTypes': [] },
      leadReport: [],
      MobileAppStartDate: '',
      MobileAppEndDate: '',
      APIHitsStartDate:'',
      APIHitsEndDate:'',
      DataNotFound: "Data Not Found",
      TokenExpireDaysForHtml: '',
      IsShowTokenExpireDaysForHtml: false,
      selectUser: 'all client',
      selectApitype: 'all',
      selectPersonalApitype:'all',
      challanApiHitInfo: { 'total': '--', 'suc_owndb':'--', 'notfound_gama': '--', 'fail': '--','timeout':'--' },
      rcPrimeHitInfo:{'rc_success': '--', 'rc_failure': '--','rc_total': '--'},
      serviceHitInfo:{'service_success': '--', 'service_failure': '--','service_total': '--'},
      totalHitInfo:{'total_success': '--', 'total_failure': '--','total_hits': '--'},
      userHitInfo: {'total_users': '--', 'new_registered_user': '--', 'logged_users': '--'},
      apiHitReportLoading: false,
      backDate:'',
      docInfoSelectClient: 'all client',
      docInfoStartDate: '',
      docInfoEndDate: '',
      docInfoSecShow: false,
      docInfoData:{},
      appInfoSecShow: false,
    }
  }

  componentDidMount() {
    //console.log(reactLocalStorage.get("authToken"));
    //var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
/*
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var today = new Date();
    var d;
    var month;
    var months = [];
    for (var i = 6; i > -1; i -= 1) {
        d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        var lastdate =new Date(today.getFullYear(), (today.getMonth()- i)+1, 0).getDate();
        console.log(today.getFullYear(),monthNames[d.getMonth()],lastdate);
        months.push("01 "+monthNames[d.getMonth()] + ',' + d.getFullYear()+" - "+"15 "+monthNames[d.getMonth()] + ',' + d.getFullYear());
        var ToBeCurrentSlot="01 "+monthNames[d.getMonth()] + ',' + d.getFullYear()+" - "+"15 "+monthNames[d.getMonth()] + ',' + d.getFullYear();       
        if(today.getDate() <= 15 && d.getMonth() === today.getMonth())
        {
          break;
        }
        months.push("16 "+monthNames[d.getMonth()] + ',' + d.getFullYear()+" - "+lastdate+" "+monthNames[d.getMonth()] + ',' + d.getFullYear());
        ToBeCurrentSlot="16 "+monthNames[d.getMonth()] + ',' + d.getFullYear()+" - "+lastdate+" "+monthNames[d.getMonth()] + ',' + d.getFullYear();
      }
*/
    //console.log('months', months);

    let date_ob = new Date();
    let date = ("0" + (date_ob.getDate())).slice(-2);
    let month1 = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    var startDate = year + "-" + month1 + "-"+ date;
    var enddate = year + "-" + month1 + "-" + date;
    date_ob.setDate(date_ob.getDate() - 31);
    this.setState({
      MobileAppStartDate: startDate,
      MobileAppEndDate: enddate,
      APIHitsStartDate:startDate,
      APIHitsEndDate:enddate,
      backDate:'2023-11-01', //date_ob.toISOString().slice(0, 10)
      docInfoStartDate: startDate,//date_ob.toISOString().slice(0, 10),
      docInfoEndDate: enddate
    });
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.loadClientAnalysisData();
      //this.filterMobileReport(startDate, enddate);
      this.filterAPIHitReport(startDate, enddate,'all','all client')
    }
  }
  loadClientAnalysisData() {
    Apihelpers.getdataresponse(ClientsAnalysis).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data', res.data.data);
        let getData = res.data.data[0];
        let clientist = [{ text:'All Client', id:-1, value:'all client'}];
        res.data.data[0].api_hit_users.map((item, i) =>
          clientist.push({ text: item.text, id: item.key, value: item.id, })
        )
        //console.log('clientist', clientist);
        this.setState({
          totalClients: getData.TotalClients,
          totalClientsInfo: { 'Prepaid': getData.TotalClientsInfo.Prepaid, 'Postpaid': getData.TotalClientsInfo.Postpaid, 'TokenStatusActive': getData.TotalClientsInfo.TokenStatusActive },
          tokenActive: getData.TokenActive,
          tokenInActive: getData.TokenExpireUserInfo.length,
          tokenExpireUserInfo: getData.TokenExpireUserInfo,
          loginActiveStatus: getData.loginActiveStatus,
          loginInactiveStatus: getData.loginInactiveStatus,
          loginInactiveUserInfo: getData.loginInactiveUserInfo,
          balanceExhausted: getData.BalanceExhausted,
          balanceExhaustedUserInfo: getData.BalanceExhaustedUserInfo,
          tokenWillBeExpireDays: getData.TokenWillBeExpireDays,
          tokenWillBeExpireUserInfo: getData.TokenWillBeExpireUserInfo,
          clientist: clientist,
          TokenExpireDaysForHtml: getData.TokenExpireDaysForHtml
        });

        if (getData.TokenWillBeExpireDays > 0) {
          this.setState({ IsShowTokenExpireDaysForHtml: true });
        }
        this.filterHitReport();
      } else {
        console.log('res.data', res.data);
      }
    });
  }

  filterHitReport = () => {
    var startDate = this.state.APIHitsStartDate;
    var endDate = this.state.APIHitsEndDate;
    let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    this.state.apiHitReportLoading = true;
    var selectClient = $("#selectClient").val();
    //var selectMonth = $("#selectMonth").val();
    var apitype = $("#selectApi").val();
    if (apitype === null || apitype === '' || apitype === 'all') {
      apitype = 'all';
    }
    if (selectClient == null || selectClient == 'all client') {
      selectClient = '-1';
    }

    if (dayDiff < 16) {
      this.filterAPIHitReport(startDate, endDate,apitype,selectClient);
    } else {
      alert('Please select date range maximum 16 days');
    }
  }


  filterAPIHitReport(startDate, endDate,apitype,selectClient){
    $(".loader").show();
    let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, 'apitype':apitype };
    //console.log('inputData', inputData);
    Apihelpers.postdataresponse(Dashboard_API_Hit_Report, inputData).then(res => {
      if (res.data.status === true) {
        console.log('res.data.data', res.data.data);
        let resData = res.data.data;
        this.setState({
          totalHit: {
            'TotalHits': resData.TotalHits, 
            'TotalFailure': resData.TotalFailure, 
            'TotalOwndb': resData.TotalOwndb, 
            'OwndbFailure': resData.OwndbFailure, 
            'OwndbSucess': resData.OwndbSucess, 
            'TotalTimeout': resData.TotalTimeout, 
            'alphaTimeOut': resData.AlphaTimeOut, 
            'betaTimeOut': resData.BetaTimeOut, 
            'gammaTimeOut': resData.GammaTimeOut,
            'owndbTempSucess': resData.owndbTempSucess,
            'owndbNotFound':resData.owndbNotFound,
            'excelEmpty': resData.excelEmpty
          },
          totalHitSource: {
            'TotalAlpha': resData.TotalAlpha, 
            'AlphaSucess': resData.AlphaSucess, 
            'AlphaFailure': resData.AlphaFailure, 
            'alphaIncomplete': resData.alphaIncomplete, 
            'TotalBeta': resData.TotalBeta, 
            'BetaSucess': resData.BetaSucess, 
            'BetaFailure': resData.BetaFailure, 
            'betaIncomplete':resData.betaIncomplete, 
            'TotalGamma': resData.TotalGamma, 
            'GammaSucess': resData.GammaSucess, 
            'GammaFailure': resData.GammaFailure, 
            'gammaIncomplete':resData.gammaIncomplete, 
            'totalSourceHit': resData.TotalSourceHit, 
            'TotalSourceSucess': resData.TotalSourceSucess,
            'TotalSourceTimeOut' : resData.TotalSourceTimeOut, 
            'TotalSourceFailure' : resData.TotalSourceFailure, 
            'TotalTimeOut': resData.TotalTimeout, 
            'TotalFailure': resData.Totalfailure, 
            'TotalSourceIncomplete':resData.TotalSourceIncomplete, 
            'TotalTimeout':resData.TotalTimeout, 
            'Totalfailure':resData.Totalfailure, 
            'DeltaFailure':resData.DeltaFailure, 
            'DeltaSucess':resData.DeltaSucess, 
            'DeltatwoSuccess':resData.DeltatwoSuccess,
            'deltaCacheSucess':resData.deltaCacheSucess,
            'deltatwoFailure' : resData.DeltatwoFailure,
            'DeltaCacheFailure' : resData.DeltaCacheFailure,
            'thetaSuccess':resData.thetaSuccess,
            'TotalDelta':resData.TotalDelta,
            'deltaIncomplete':resData.deltaIncomplete, 
            'deltatwoInomplete':resData.deltatwoInomplete,
            'deltaCacheIncomplete':resData.deltaCacheIncomplete,
            'thetaIncomplete':resData.thetaIncomplete, 
            'deltaTimeOut':resData.DeltaTimeOut,
            'totalOtherHits':resData.totalOtherHits,
            'DeltatwoTimeOut': resData.DeltatwoTimeOut,
            'DeltaCacheTimeOut': resData.DeltaCacheTimeOut,
            'ThetaTimeout':resData.ThetaTimeout,
            'ThetaFailure':resData.ThetaFailure,
          },
          totalChallanSource : {
          'challanTotalApiHits' :resData.challanTotalApiHits,
          'challanTotalDBHits'  :resData.challanTotalDBHits, 
          'challanTotalGammaSucces' :resData.challanTotalGammaSucces,
          'challanTotalNotFoundGamma' :resData.challanTotalNotFoundGamma,
          'challanGammaFailure' :resData.challanGammaFailure, 
          'challanGammaTimeOut' :resData.challanGammaTimeOut,
          'challanTotalFailure':resData.challanTotalFailure,
          'challanTotalTimeOut': resData.challanTotalTimeOut,
          'challanTotalSucces': resData.challanTotalSucces,
          'challanTotalNotFound': resData.challanTotalNotFound 
          },
          totalChallanZetaSource :{ 
          'challanTotalZetaSucces' : resData.challanTotalZetaSucces, 
          'challanZetaFailure': resData.challanZetaFailure, 
          'challanTotalNotFoundZeta': resData.challanTotalNotFoundZeta, 
          'challanZetaTimeOut' : resData.challanZetaTimeOut
          },
          totalChallanDeltaSource :{ 
            'challanTotalDeltaSucces' : resData.challanTotalDeltaSucces, 
            'challanDeltaFailure': resData.challanDeltaFailure, 
            'challanTotalNotFoundDelta': resData.challanTotalNotFoundDelta, 
            'challanDeltaTimeOut' : resData.challanDeltaTimeOut,
            'challanTotalDeltaProSucces' : resData.challanTotalDeltaProSucces, 
            'challanDeltaProFailure': resData.challanDeltaProFailure, 
            'challanTotalNotFoundDeltaPro': resData.challanTotalNotFoundDeltaPro, 
            'challanDeltaProTimeOut' : resData.challanDeltaProTimeOut
            },
          totalServiceHistorySource:{
          'serviceHitsTotal':resData.serviceHitsTotal,
          'serviceTotalSuccess':resData.serviceTotalSuccess,
          'serviceTotalFailure':resData.serviceTotalFailure
          },
          totalUsedCarPricingSource:{
            'usedCarPricingTotal':resData.usedCarPricingHitsTotal,
            'usedCarPricingSuccess': resData.usedCarPricingTotalSuccess,
            'usedCarPricingTimeOut':resData.usedCarPricingTotalTimeOut,
            'usedCarPricingFailure':resData.usedCarPricingTotalFailure 
          },

          totalUsedCarPricingV2Source:{
            'usedCarPricingV2Total':resData.usedCarPricingV2HitsTotal,
            'usedCarPricingV2Success': resData.usedCarPricingV2TotalSuccess,
            'usedCarPricingV2TimeOut':resData.usedCarPricingV2TotalTimeOut,
            'usedCarPricingV2Failure':resData.usedCarPricingV2TotalFailure 
          },

          totalFreeRCSource:{
            'freeRCTotal':resData.freeRCHitsTotal,
            'freeRCSuccess': resData.freeRCTotalSuccess,
            'freeRCTimeOut':resData.freeRCTotalTimeOut,
            'freeRCFailure':resData.freeRCTotalFailure 
          } 
        });
      } else {
        console.log('res.data', res.data);
        this.setState({
          totalHit: {
            'TotalHits': 0, 
            'TotalFailure': 0, 
            'TotalOwndb': 0, 
            'OwndbFailure': 0, 
            'OwndbSucess': 0, 
            'TotalTimeout': 0, 
            'alphaTimeOut': 0, 
            'betaTimeOut': 0, 
            'gammaTimeOut': 0,
            'owndbTempSucess': 0,
            'owndbNotFound':0,
            'excelEmpty': 0
          },
          totalHitSource: {
            'TotalAlpha': 0, 
            'AlphaSucess': 0, 
            'AlphaFailure': 0, 
            'alphaIncomplete': 0, 
            'TotalBeta': 0, 
            'BetaSucess': 0, 
            'BetaFailure': 0, 
            'betaIncomplete':0, 
            'TotalGamma': 0, 
            'GammaSucess': 0, 
            'GammaFailure': 0, 
            'gammaIncomplete':0, 
            'totalSourceHit': 0, 
            'TotalSourceSucess': 0, 
            'TotalSourceFailure':0,
            'TotalSourceTimeOut':0,
            'TotalTimeOut': 0, 
            'TotalFailure': 0, 
            'TotalSourceIncomplete':0, 
            'TotalTimeout':0, 
            'Totalfailure':0, 
            'DeltaFailure':0, 
            'DeltaSucess':0, 
            'DeltatwoSuccess':0,
            'deltaCacheSucess':0,
            'thetaSuccess':0, 
            'TotalDelta':0,
            'deltaIncomplete':0, 
            'deltatwoInomplete':0,
            'deltaCacheIncomplete':0,
            'thetaIncomplete':0, 
            'deltaTimeOut':0,
            'DeltatwoTimeOut':0,
            'DeltaCacheTimeOut':0,
            'totalOtherHits':0,
            'deltatwoFailure':0,
            'DeltaCacheFailure':0,
            'ThetaTimeout':0,
            'ThetaFailure':0
          },
          totalChallanSource : {
            'challanTotalApiHits' :0,
            'challanTotalDBHits'  :0, 
            'challanTotalGammaSucces' :0,
            'challanTotalNotFoundGamma' :0,
            'challanGammaFailure' :0, 
            'challanGammaTimeOut' :0,
            'challanTotalFailure':0,
            'challanTotalTimeOut' :0,
            'challanTotalSucces':0,
            'challanTotalNotFound':0 
            },
          totalChallanZetaSource :{ 
              'challanTotalZetaSucces' :0,
              'challanZetaFailure':0,
              'challanTotalNotFoundZeta':0,
              'challanZetaTimeOut' :0
            },
            totalChallanDeltaSource :{ 
              'challanTotalDeltaSucces' :0,
              'challanDeltaFailure':0,
              'challanTotalNotFoundDelta':0,
              'challanDeltaTimeOut' :0,
              'challanTotalDeltaProSucces' :0,
              'challanDeltaProFailure':0,
              'challanTotalNotFoundDeltaPro':0,
              'challanDeltaProTimeOut' :0
            },
          totalServiceHistorySource: {
            'serviceHitsTotal': 0,
            'serviceTotalSuccess': 0,
            'serviceTotalFailure': 0
           },
           totalUsedCarPricingSource:{
            'usedCarPricingTotal': 0,
            'usedCarPricingSuccess': 0,
            'usedCarPricingTimeOut': 0,
            'usedCarPricingFailure': 0 
          },

          totalUsedCarPricingV2Source:{
            'usedCarPricingV2Total': 0,
            'usedCarPricingV2Success': 0,
            'usedCarPricingV2TimeOut': 0,
            'usedCarPricingV2Failure': 0 
          },
          totalFreeRCSource:{
            'freeRCTotal': 0,
            'freeRCSuccess': 0,
            'freeRCTimeOut': 0,
            'freeRCFailure': 0 
          },  
        });
      }
      $(".loader").hide();
      this.state.apiHitReportLoading = false;
    });
  }
  filterMobileApp = () => {
    var startDate = this.state.MobileAppStartDate;
    var endDate = this.state.MobileAppEndDate;
    let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (dayDiff <= 16) {
      this.filterMobileReport(startDate, endDate);
    } else {
      alert('Please select date range maximum 16 days');
    }
  }
  filterMobileReport = (startDate, endDate) => {
    $(".loader").show();
    let inputData = { 'startDate': startDate, 'endDate': endDate };
    //console.log('inputData', inputData);
    Apihelpers.postdataresponse(Dashboard_Mobile_App, inputData).then(res => {
      if (res.data.status === true) {
        console.log('mobile-app: res.data.data', res.data.data);
        let resData = res.data.data;
        console.log(resData);
        var reports = resData["LeadReportInfo"];

        this.setState({
          mobileApplication: { 'TotalLeads': resData["Total Lead"] },
          leadReport: reports
        });

        // user hits
        var totalUserHits = resData["total_users"];
        var newRegisterUser = resData["new_register_user"];
        var loggedUsers = resData["logged_users"];
        this.setState({
          userHitInfo: {'total_users': totalUserHits, 'new_registered_user': newRegisterUser, 'logged_users' : loggedUsers },  
        });
        // total hits of prime and service history
        var totalApiHits = resData["totalApiHits"]; 
        var totalSuccesHits = resData["totalSuccesHits"]; 
        var totalFilureHits = resData["totalFilureHits"];
        console.log('total_success', totalSuccesHits, 'total_failure', totalFilureHits,'total_hits', totalApiHits)
        this.setState({
        totalHitInfo:{'total_success': totalSuccesHits, 'total_failure': totalFilureHits,'total_hits': totalApiHits},
        })

        //service history hits
        var serviceTotal = resData["serviceTotal"];
        var serviceSuccess = resData["serviceSuccess"];
        var serviceFailure = resData["serviceFailure"];
        console.log('service_success', serviceSuccess, 'service_failure', serviceFailure,'service_total', serviceTotal) 
        this.setState({
          serviceHitInfo:{'service_success': serviceSuccess, 'service_failure': serviceFailure,'service_total': serviceTotal},
        })
   
         //prime hits
         var rcTotal = resData["prime_total"];
         var rcSuccess = resData["prime_success"];
         var rcFailure = resData["prime_failure"];
         console.log("rc_total",rcTotal, "rc_sucess",rcSuccess, "rc_failure",rcFailure)
         this.setState({
          rcPrimeHitInfo: {'rc_success': rcSuccess, 'rc_failure': rcFailure , 'rc_total':rcTotal, }
        });
       
        //challan hits
        var total = resData["challan_total"];
        var compOwnDb = resData["challan_database"];
        var gamaNot = resData["challa_gamma_not_found"];
        var fail = resData["challa_failure"];
        var timeOut = resData["challan_timeout"];
        this.setState({
          challanApiHitInfo: { 'total': total, 'suc_owndb': compOwnDb, 'notfound_gama': gamaNot, 'fail': fail, 'timeout': timeOut}
        });
        if (this.state.apiHitReportLoading === false) {
          $(".loader").hide();
        }
      } else {
        console.log('res.data', res.data);
      }
    });
  }
  loadMore = (e, sourcetype) => {
    let tr = $(e.target).parents('.next-child');
    if (tr.hasClass('open')) {
      tr.removeClass('open');
    } else {
      var startDate = this.state.APIHitsStartDate;
      var endDate = this.state.APIHitsEndDate;
      let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
      dayDiff = dayDiff / (1000 * 60 * 60 * 24);
      this.state.apiHitReportLoading = true;
      var selectClient = $("#selectClient").val();
      var apitype = $("#selectApi").val();
      if (apitype === null || apitype === '' || apitype === 'all') {
        apitype = 'all';
      }
      if (selectClient == null || selectClient == 'all client') {
        selectClient = '-1';
      }
      $(".loader").show();
      let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, 'apitype':apitype, 'apiTypeSource': sourcetype };
      Apihelpers.postdataresponse('Dashboard/hit_reports_for_timeout_and_failure', inputData).then(res=>{
        if(res.data.status === true) {
          console.log('res.data.data', res.data.data);
          let data = res.data.data;
          tr.next('tr').find('table td').eq(0).text('All Hits: '+data.allHits);
          tr.next('tr').find('table td').eq(1).text('Not Found: '+data.failure);
          tr.next('tr').find('table td').eq(2).text('Time Out: '+data.timeOut);
        } else {
          alert('Please Check Your Plan Type....');
        }
        $(".loader").hide();
      });
      $('.next-child').removeClass('open');
      tr.addClass('open');
    }
    //console.log('tr',tr);
  }
  filterDocumentInfo = () => {
    let startDate = this.state.docInfoStartDate;
    let endDate = this.state.docInfoEndDate;
    let selectClient = this.state.docInfoSelectClient;
    let api_type = this.state.selectPersonalApitype;
    if (selectClient == null || selectClient == 'all client') {
      selectClient = '-1';
    }
    //$(".loader").show();
    let inputData = {'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, "apitype": api_type};
    Apihelpers.postdataresponse('Dashboard/reports-for-personalnfoapihit',inputData).then(res => {
      if(res.data.status === true) {
        //console.log('res.data.data',res.data.data);
        this.setState({docInfoData:res.data.data});
      } else {
        console.log('res.data',res.data);
        this.setState({docInfoData:{}});
      }
    })
  }
  showDocInfoSec = () => {
    if (this.state.docInfoSecShow) {
      this.setState({
        docInfoSecShow:false
      });
    } else {
      this.filterDocumentInfo();
      this.setState({
        docInfoSecShow:true
      });
    }
  }
  printVal = (val) => {
    return (val === undefined || val === "") ? '--' : val;
  }

  showAppInfoSec = () => {
    if (this.state.appInfoSecShow) {
      this.setState({
        appInfoSecShow:false
      });
    } else {
      this.filterMobileApp();
      this.setState({
        appInfoSecShow:true
      });
    }
  }
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {

      return (
        <React.Fragment>
          <div className="wrapper dashboardPage">
            <Header />
            <div className="container">
              <div className="whiteBox">
                {/* <h3 className="title">Dashboard Coming...</h3> */}
                <div className="row">
                  <div className="col-md-4">
                    <div className="infoTabe">
                      <h4 className="headBg">Clients Analysis</h4>
                      <ul>
                        <li>
                          <span className="key">Total Clients</span>
                          <div className="val">{this.state.totalClients}
                            <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                                Postpaid: <strong>{this.state.totalClientsInfo.Postpaid}</strong><br />
                                Prepaid: <strong>{this.state.totalClientsInfo.Prepaid}</strong><br />
                                Token Status Active: <strong>{this.state.totalClientsInfo.TokenStatusActive}</strong><br />
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <ul>
                            <li>
                              <span className="key">Login Status Active:</span>
                              <div className="val">
                                {this.state.loginActiveStatus}
                              </div>
                            </li>
                            <li>
                              <span className="key">Login Status InActive:</span>
                              <div className="val">
                                {this.state.loginInactiveStatus}
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText toolTipTextB">
                                    {this.state.loginInactiveUserInfo.map((item, i) => <span key={i}>{item}</span>)}
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li>
                              <span className="key">Token Status Active:</span>
                              <div className="val">
                                {this.state.tokenActive}
                              </div>
                            </li>
                            <li>
                              <span className="key">Token Status InActive:</span>
                              <div className="val">
                                {this.state.tokenInActive}
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText toolTipTextB">
                                    {this.state.tokenExpireUserInfo.map((item, i) => <span key={i}>{item} </span>)}
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li>
                              <span className="key">Balance Exhausted:</span>
                              <div className="val">
                                {this.state.balanceExhausted}
                                <div className="toolTip">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                    {this.state.balanceExhaustedUserInfo.map((item, i) => <span key={i}>{item}<br /></span>)}
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <span className="key">Token Will be Expire in Last {this.state.TokenExpireDaysForHtml} Days</span>
                          <div className="val">
                            {this.state.tokenWillBeExpireDays}
                            {this.state.IsShowTokenExpireDaysForHtml === true ?
                              <div className="toolTip">
                                <i className="infoIcon"></i>
                                <div className="toolTipText">
                                  {this.state.tokenWillBeExpireUserInfo.map((item, i) => <span key={i}>{item}<br /></span>)}
                                </div>
                              </div>
                              : ""}
                          </div>
                        </li>
                      </ul>
                    </div>
                    {/* <div className="infoTabe">
											<h4 className="headBg">RTO Clients Amount Status</h4>
											<ul>
												<li>
													<div className="key">is dummy text used</div>
													<div className="val">1000</div>
													<ul>
														<li>
															<span className="key">is dummy text used</span>
															<span className="val">300</span>
														</li>
														<li>
															<span className="key">is dummy text used</span>
															<span className="val">500</span>
														</li>
													</ul>
												</li>
											</ul>
										</div> */}
                  </div>
                  <div className="col-md-8">
                    <div className="infoTabe apiHitInfo">
                      <h4 className="headBg">API Hits Reports</h4>
                      <div className="blockFilter form">
                        <div className="row">
                          <div className="col-md">
                            <div className="form-group">
                              <label className="control-title">Select Client</label>
                              <Select2
                                data={this.state.clientist}
                                options={{
                                  placeholder: 'select client',
                                }}
                                id="selectClient"
                                className="form-control"
                                value={this.state.selectUser}
                                onChange={(e) => this.setState({ selectUser: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md">
                            <div className="form-group">
                              <label className="control-title">Select Plan Type</label>
                              {/* <Select2
                                data = {[{text:'All',value:'all'}, {text:'RCPrime',value:'9'}, {text:'RCExcel',value:'10'}]}
                                options={{
                                  placeholder: 'select api',
                                }}
                                id="selectApi"
                                className="form-control"
                                value={this.state.  }
                                onChange={(e) => this.setState({ selectApitype: e.target.value })}
                              /> */}
                              <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectApitype: e.target.value })}>
                                <option value="all">All</option>
                                <option value="9">RCPrime</option>
                                <option value="10">RCExcel</option>
                                <option value="2">Challan</option>
                                <option value="15">RCPrimeReverse</option>
                                <option value="3">Service History</option>
                                <option value="14">Used Car Pricing</option>
                                <option value="0">Free RC</option>
                                <option value="16">RCPrimeReverseBasic</option>
                                <option value="19">Used Car Pricing v2</option>
                                <option value="32">comboPrime</option>
                                <option value="33">comboChallan</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md">
                            <div className="form-group">
                            <label className="control-title">Select Start Range</label>
                            <input className="form-control" min={this.state.backDate} id="startDate" value={this.state.APIHitsStartDate} placeholder="Start Date" type="date"
                              onChange={(e) => this.setState({ APIHitsStartDate: e.target.value })} />
                            </div>
                           </div>
                          <div className="col-md">
                            <div className="form-group">
                            <label className="control-title">Select End Range</label>
                            <input className="form-control" min={this.state.backDate} id="endDate" value={this.state.APIHitsEndDate} placeholder="Start Date" type="date"
                              onChange={(e) => this.setState({ APIHitsEndDate: e.target.value })} />
                              </div>
                          </div>
                          <div className="col-auto">
                            <button onClick={this.filterHitReport} className="blueBtn">Filter</button>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <ul>
                            <li>
                              <div className="key">Total API Hits</div>
                              <div className="val">{this.state.totalHit.TotalHits}</div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul>
                            <li>
                              <div className="key">Total Hits &nbsp; 
                              <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Total (RCPrime, RCExcel, RCPrimeReverse, RCPrimeReverseBasic & comboPrime) Hits
                              </div>
                               </div>
                               </div>
                              <div className="val">{this.state.totalHitSource.totalSourceHit}</div>
                              <ul>
                                <li>
                                  <span className="key">Successful</span>
                                  <span className="val">{this.state.totalHitSource.TotalSourceSucess}</span>
                                </li>
                                {/* <li>
                                  <span className="key">Not Found</span>
                                  <span className="val">--</span>
                                </li> */}
                                <li>
                                  <span className="key">Incomplete</span>
                                  <span className="val">{this.state.totalHitSource.TotalSourceIncomplete}</span>
                                </li>
                                <li>
                                  <span className="key">Not Found</span>
                                  <span className="val">{this.state.totalHitSource.TotalSourceFailure}</span>
                                </li> 
                                 <li>
                                  <span className="key">TimeOut</span>
                                  <span className="val">{this.state.totalHitSource.TotalSourceTimeOut}</span>
                                </li> 
                                <li>
                                  <span className="key">Others</span>
                                  <span className="val">{this.state.totalHitSource.totalOtherHits}</span>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul>
                            <li>
                              <div className="key">Our DB Hits &nbsp; 
                              <div className="toolTip">
                              <i className="infoIcon"></i>
                              <div className="toolTipText">
                              Total (RCPrime, RCExcel, RCPrimeReverse, RCPrimeReverseBasic & comboPrime) Hits
                               </div>
                               </div>
                               </div>
                              <div className="val">{this.state.totalHit.TotalOwndb}</div>
                              <ul>
                                <li>
                                  <span className="key">Successful</span>
                                  <div className="val">{this.state.totalHit.OwndbSucess}</div>
                                </li>
                                <li>
                                  <span className="key">Failure</span>
                                  <div className="val">{this.state.totalHit.OwndbFailure}</div>
                                </li>
                                <li>
                                  <span className="key">Temp Sucess</span>
                                  <span className="val">{this.state.totalHit.owndbTempSucess}</span>
                                </li>
                                <li>
                                  <span className="key">Not Found</span>
                                  <span className="val">{this.state.totalHit.owndbNotFound}</span>
                                </li>
                              </ul>
                            </li>
                          </ul>
                          <ul>
                            <li>
                              <div className="key">Not Processed</div>
                              <div className="val">{this.state.totalHit.excelEmpty}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="dasInfoTable">
                        <div className="table-responsive">
                          <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                                <th>API Source</th>
                                {/* <th>All Hits</th> */}
                                <th>Success</th>
                                <th>Incomplete</th>
                               <th>Not Found</th>  
                                <th>TimeOut</th> 
                                {/* <th>More Details</th>*/}
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="next-child">
                                <td className="black">All Source</td>
                                {/* <td>{this.state.totalHitSource.totalSourceHit}</td> */}
                                <td>{this.state.totalHitSource.TotalSourceSucess}</td>
                                <td>{this.state.totalHitSource.TotalSourceIncomplete}</td>
                                 <td>{this.state.totalHitSource.TotalSourceFailure}</td> 
                                 <td>{this.state.totalHitSource.TotalSourceTimeOut}</td> 
                                {/* <td><span className="more" onClick={(e) => this.loadMore(e,'all')}><i className="fa fa-chevron-circle-down"></i></span></td>*/}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">ALPHA</td>
                                {/* <td>{this.state.totalHitSource.TotalAlpha}</td> */}
                                <td>{this.state.totalHitSource.AlphaSucess}</td>
                                <td>{this.state.totalHitSource.alphaIncomplete}</td>
                                 <td>{this.state.totalHitSource.AlphaFailure}</td>
                                 <td>{this.state.totalHit.alphaTimeOut}</td> 
                                {/*<td><span className="more" onClick={(e) => this.loadMore(e,'zoop')}><i className="fa fa-chevron-circle-down"></i></span></td>*/}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">BETA</td>
                                {/* <td>{this.state.totalHitSource.TotalBeta}</td> */}
                                <td>{this.state.totalHitSource.BetaSucess}</td>
                                <td>{this.state.totalHitSource.betaIncomplete}</td>
                                <td>{this.state.totalHitSource.BetaFailure}</td>
                                <td>{this.state.totalHit.betaTimeOut}</td>
                               {/* <td><span className="more" onClick={(e) => this.loadMore(e,'surepass')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">Gamma</td>
                                {/* <td>{this.state.totalHitSource.TotalGamma}</td> */}
                                <td>{this.state.totalHitSource.GammaSucess}</td>
                                <td>{this.state.totalHitSource.gammaIncomplete}</td>
                                <td>{this.state.totalHitSource.GammaFailure}</td>                                
                                <td>{this.state.totalHit.gammaTimeOut}</td> 
                               {/* <td><span className="more" onClick={(e) => this.loadMore(e,'gamma')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">Delta</td>
                                {/* <td>{this.state.totalHitSource.TotalDelta}</td> */}
                                <td>{this.state.totalHitSource.DeltaSucess}</td>
                                <td>{this.state.totalHitSource.deltaIncomplete}</td>
                                 <td>{this.state.totalHitSource.DeltaFailure}</td>     
                                 <td>{this.state.totalHitSource.deltaTimeOut}</td> 
                               {/* <td><span className="more" onClick={(e) => this.loadMore(e,'delta')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">Deltav2</td>
                                {/* <td>{this.state.totalHitSource.TotalDelta}</td> */}
                                <td>{this.state.totalHitSource.DeltatwoSuccess}</td>
                                <td>{this.state.totalHitSource.deltatwoInomplete}</td>
                                {console.log("delta two failure-->",this.state.totalHitSource.deltatwoFailure)}
                                <td>{this.state.totalHitSource.deltatwoFailure}</td> 
                                <td>{this.state.totalHitSource.DeltatwoTimeOut}</td>
                                {/* <td><span className="more" onClick={(e) => this.loadMore(e,'deltav2')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">DeltaCache</td>
                                <td>{this.state.totalHitSource.deltaCacheSucess}</td>
                                <td>{this.state.totalHitSource.deltaCacheIncomplete}</td>
                                <td>{this.state.totalHitSource.DeltaCacheFailure}</td> 
                                <td>{this.state.totalHitSource.DeltaCacheTimeOut}</td>
                               {/* <td><span className="more" onClick={(e) => this.loadMore(e,'deltaCache')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                              <tr className="next-child">
                                <td className="black">Theta</td>
                                <td>{this.state.totalHitSource.thetaSuccess}</td>
                                <td>{this.state.totalHitSource.thetaIncomplete}</td>
                                <td>{this.state.totalHitSource.ThetaFailure}</td> 
                                <td>{this.state.totalHitSource.ThetaTimeout}</td>
                               {/* <td><span className="more" onClick={(e) => this.loadMore(e,'theta')}><i className="fa fa-chevron-circle-down"></i></span></td> */}
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                                <td colSpan={3}>
                                  <table className="child-table">
                                    <tr>
                                      <td>All Hits: --</td>
                                      <td>Not Found: --</td>
                                      <td>Time Out: --</td>
                                      <td>&nbsp;</td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px", display:"none" }}>
                            <thead>
                              <tr>
                                <th>&nbsp;</th>
                                <th>All Hits</th>
                                <th>Success <br />Own DB</th>
                                <th>Success <br />Gamma</th>
                                <th>Not Found <br />Gamma</th>
                                <th>Failure</th>
                                <th>Time Out</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="black">Challan</td>
                                <td className="black"><b>{this.state.totalChallanSource.challanTotalApiHits}</b></td>
                                <td>{this.state.totalChallanSource.challanTotalDBHits}</td>
                                <td>{this.state.totalChallanSource.challanTotalGammaSucces}</td>
                                <td>{this.state.totalChallanSource.challanTotalNotFoundGamma}</td>
                                <td>{this.state.totalChallanSource.challanGammaFailure}</td>
                                <td>{this.state.totalChallanSource.challanGammaTimeOut}</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                              <th>
                              <div className="key">Challan &nbsp; 
                                <div className="toolTip rightAlin">
                                  <i className="infoIcon"></i>
                                  <div className="toolTipText">
                                    Total (Challan & comboChallan) Hits
                                  </div>
                                </div>
                               </div>
                               </th>
                                <th>Success </th>
                                <th>Not Found</th>
                                <th>Failure</th>
                                <th>Time Out</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="black">All Source</td>
                                <td>{this.state.totalChallanSource.challanTotalSucces}</td>
                                <td>{this.state.totalChallanSource.challanTotalNotFound}</td>
                                <td>{this.state.totalChallanSource.challanTotalFailure}</td>
                                <td>{this.state.totalChallanSource.challanTotalTimeOut}</td>
                              </tr>
                              <tr>
                                <td className="black">Own Database</td>
                                <td>{this.state.totalChallanSource.challanTotalDBHits}</td>
                                <td>--</td>
                                <td>--</td>
                                <td>--</td>
                              </tr>
                              <tr>
                                <td className="black">Gamma</td>
                                <td>{this.state.totalChallanSource.challanTotalGammaSucces}</td>
                                <td>{this.state.totalChallanSource.challanTotalNotFoundGamma}</td>
                                <td>{this.state.totalChallanSource.challanGammaFailure}</td>
                                <td>{this.state.totalChallanSource.challanGammaTimeOut}</td>
                              </tr>
                              <tr>
                                <td className="black">Zeta</td>
                                <td>{this.state.totalChallanZetaSource.challanTotalZetaSucces}</td>
                                <td>{this.state.totalChallanZetaSource.challanTotalNotFoundZeta}</td>
                                <td>{this.state.totalChallanZetaSource.challanZetaFailure}</td>
                                <td>{this.state.totalChallanZetaSource.challanZetaTimeOut}</td>
                              </tr>
                              <tr>
                                <td className="black">Delta</td>
                                <td>{this.state.totalChallanDeltaSource.challanTotalDeltaSucces}</td>
                                <td>{this.state.totalChallanDeltaSource.challanTotalNotFoundDelta}</td>
                                <td>{this.state.totalChallanDeltaSource.challanDeltaFailure}</td>
                                <td>{this.state.totalChallanDeltaSource.challanDeltaTimeOut}</td>
                              </tr>
                              <tr>
                                <td className="black">Delta Pro</td>
                                <td>{this.state.totalChallanDeltaSource.challanTotalDeltaProSucces}</td>
                                <td>{this.state.totalChallanDeltaSource.challanTotalNotFoundDeltaPro}</td>
                                <td>{this.state.totalChallanDeltaSource.challanDeltaProFailure}</td>
                                <td>{this.state.totalChallanDeltaSource.challanDeltaProTimeOut}</td>
                              </tr>
                            </tbody>
                          </table>

                          <div className="table-responsive">
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                                <th>&nbsp;</th>
                                <th>All Hits</th>
                                <th>Success</th>
                                <th>Failure</th>
                              </tr>
                            </thead>
                              <tr>
                                <td className="black">Service History</td>
                                <td className="black"><b>{this.state.totalServiceHistorySource.serviceHitsTotal}</b></td>
                                <td>{this.state.totalServiceHistorySource.serviceTotalSuccess}</td>
                                <td>{this.state.totalServiceHistorySource.serviceTotalFailure}</td>
                              </tr>
                            <tbody>
                            </tbody>
                          </table>
                        </div>
                        <div className="table-responsive">
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                                <th>&nbsp;</th>
                                <th>All Hits</th>
                                <th>Success</th>
                                <th>Time Out</th>
                                <th>Failure</th>
                              </tr>
                            </thead>
                              <tr>
                                <td className="black">Used Car Pricing</td>
                                <td className="black"><b>{this.state.totalUsedCarPricingSource.usedCarPricingTotal}</b></td>
                                <td>{this.state.totalUsedCarPricingSource.usedCarPricingSuccess}</td>
                                <td>{this.state.totalUsedCarPricingSource.usedCarPricingTimeOut}</td>
                                <td>{this.state.totalUsedCarPricingSource.usedCarPricingFailure}</td>
                              </tr>
                              <tr>

                                <td className="black">Used Car Pricing V2</td>
                                <td className="black"><b>{this.state.totalUsedCarPricingV2Source.usedCarPricingV2Total}</b></td>
                                <td>{this.state.totalUsedCarPricingV2Source.usedCarPricingV2Success}</td>
                                <td>{this.state.totalUsedCarPricingV2Source.usedCarPricingV2TimeOut}</td>
                                <td>{this.state.totalUsedCarPricingV2Source.usedCarPricingV2Failure}</td>
                              </tr>
                              <tr>
                                <td className="black">Free RC</td>
                                <td className="black"><b>{this.state.totalFreeRCSource.freeRCTotal}</b></td>
                                <td>{this.state.totalFreeRCSource.freeRCSuccess}</td>
                                <td>{this.state.totalFreeRCSource.freeRCTimeOut}</td>
                                <td>{this.state.totalFreeRCSource.freeRCFailure}</td>
                              </tr>
                            <tbody>
                            </tbody>
                          </table>
                        </div>
                        
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="infoTabe docInfoSec">
                  <h4 className="headBg">
                    <span>Document Verification API Hits Report</span>
                    <span className="arrow" onClick={this.showDocInfoSec}><i className="fa fa-chevron-circle-down"></i></span>
                  </h4>
                  <div className="blockFilter form" style={this.state.docInfoSecShow ? {}:{display:'none'}}>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Select Client</label>
                          <Select2
                            data={this.state.clientist}
                            options={{
                              placeholder: 'select client',
                            }}
                            //id="docInfoSelectClient"
                            className="form-control"
                            value={this.state.docInfoSelectClient}
                            onChange={(e) => this.setState({ docInfoSelectClient: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="col">
                            <div className="form-group">
                              <label className="control-title">Select Plan Type</label>
                              <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectPersonalApitype: e.target.value })}>
                                <option value="all">All</option>
                                <option value="21">Pan Fetch</option>
                                <option value="26">Pan Extensive</option>
                                <option value="34">Aadhaar Fetch</option>
                                <option value="24">Aadhaar Extraction</option>
                                <option value="22">Basic Forgery</option>
                                <option value="23">Advance Forgery</option>                                
                              </select>
                            </div>
                          </div>
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Select Start Range</label>
                          <input className="form-control" min={this.state.backDate} value={this.state.docInfoStartDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({docInfoStartDate: e.target.value})} />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Select End Range</label>
                          <input className="form-control" min={this.state.backDate} value={this.state.docInfoEndDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ docInfoEndDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <button className="blueBtn" onClick={this.filterDocumentInfo}>Filter Now</button>
                      </div>
                    </div>
                    <div className="dasInfoTable">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>API Type</th>
                              <th>Total</th>
                              <th>Success</th>
                              <th>Failure</th>
                              <th>Time Out</th>
                            </tr>
                          </thead>
                          <tbody>
                          <tr>
                              <td>Own Database</td>
                              <td>{this.printVal(this.state.docInfoData?.databaseCounts?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.databaseCounts?.sucess)}</td>
                              <td>--</td>
                              <td>--</td>
                            </tr>
                            <tr>
                              <td>Gamma</td>
                              <td>{this.printVal(this.state.docInfoData?.gammaCounts?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.gammaCounts?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.gammaCounts?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.gammaCounts?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Delta</td>
                              <td>{this.printVal(this.state.docInfoData?.deltaCounts?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.deltaCounts?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.deltaCounts?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.deltaCounts?.timeOut)}</td>
                            </tr>
                          { /* <tr>
                              <td>Pan Fetch</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.ownDb)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Pan Extensive</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.ownDb)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Basic Forgery</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Advance Forgery</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Aadhaar Extraction</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.timeOut)}</td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div className="infoTabe appInfoSec">
                  <h4 className="headBg">
                    <span>RTO Mobile Application Analysis</span>
                    <span className="arrow" onClick={this.showAppInfoSec}><i className="fa fa-chevron-circle-down"></i></span>
                  </h4>
                  <div style={(this.state.appInfoSecShow) ? {} : {display:'none'}}>
                    <div className="blockFilter form">
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                            <label className="control-title">Select Start Range</label>
                            <input className="form-control" min={this.state.backDate} id="startDate" value={this.state.MobileAppStartDate} placeholder="Start Date" type="date"
                              onChange={(e) => this.setState({ MobileAppStartDate: e.target.value })} />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <label className="control-title">Select End Range</label>
                            <input className="form-control" min={this.state.backDate} id="endDate" value={this.state.MobileAppEndDate} placeholder="Start Date" type="date"
                              onChange={(e) => this.setState({ MobileAppEndDate: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-auto">
                          <button className="blueBtn" onClick={this.filterMobileApp}>Filter Now</button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <ul>
                          {<li>
                            <div className="key">Total Users</div>
                            <div className="val">{this.state.userHitInfo.total_users}</div>
                            <ul>
                              <li>
                                <span className="key">Sign Up Users</span>
                                <span className="val">{this.state.userHitInfo.new_registered_user}</span>
                              </li>
                              <li>
                              <span className="key">  Logged Users </span>
                              <span className="val"> {this.state.userHitInfo.logged_users}  </span>
                              </li> 
                                  
                            
                            </ul>
                          </li>}
                          <li>
                            <div className="key">Total Leads</div>
                            <div className="val">{this.state.mobileApplication.TotalLeads}</div>

                            <ul>

                              {this.state.leadReport.length <= 0 ? <li><b><center>{this.state.DataNotFound}</center></b></li> : this.state.leadReport.map(list => {
                                return (
                                  <li>
                                    <span className="key">{list.reportName}</span>
                                    <span className="val">{list.reportValue}</span>
                                  </li>
                                )
                              })}
                            </ul>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-7">
                        <div className="dasInfoTable">
                          <div className="table-responsive">
                            <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                              <thead>
                                <tr>
                                  <th>&nbsp;</th>
                                  <th>All Hits</th>
                                  <th>Success </th>                               
                                  <th>Not Found </th>
                                  <th>Failure</th>
                                  <th>Time Out</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="black">Challan</td>
                                  <td>{this.state.challanApiHitInfo.total}</td>
                                  <td>{this.state.challanApiHitInfo.suc_owndb}</td>
                                  <td>{this.state.challanApiHitInfo.notfound_gama}</td>
                                  <td>{this.state.challanApiHitInfo.fail}</td>
                                  <td>{this.state.challanApiHitInfo.timeout}</td>
                                </tr>
                              </tbody>
                            </table> 

                          </div>
                          <br />
                          <div className="table-responsive">
                            <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                              <thead>
                                <tr>
                                  <th>&nbsp;</th>
                                  <th>Success</th>
                                  <th>Failure</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                                <tr>
                                  <td className="black">Rc Prime</td>
                                  <td>{this.state.rcPrimeHitInfo.rc_success}</td>
                                  <td>{this.state.rcPrimeHitInfo.rc_failure}</td>
                                  <td>{this.state.rcPrimeHitInfo.rc_total}</td>
                                </tr>
                                <tr>
                                  <td className="black">Service History</td>
                                  <td>{this.state.serviceHitInfo.service_success}</td>
                                  <td>{this.state.serviceHitInfo.service_failure}</td>
                                  <td>{this.state.serviceHitInfo.service_total}</td>
                                </tr>
                                <tr>
                                  <td className="black">Total</td>
                                  <td>{this.state.totalHitInfo.total_success}</td>
                                  <td>{this.state.totalHitInfo.total_failure}</td>
                                  <td>{this.state.totalHitInfo.total_hits}</td>
                                </tr>
                              <tbody>
                              </tbody>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default Dashboard;
